import { render } from "./saturation.vue?vue&type=template&id=6e2fed33"
import script from "./saturation.vue?vue&type=script&lang=js"
export * from "./saturation.vue?vue&type=script&lang=js"

import "./saturation.vue?vue&type=style&index=0&id=6e2fed33&lang=css"
script.render = render

export default script